import { Menu } from './components/Menu'
import './scss/menu.scss'
import type { MenuAppProps } from "@/components/menu/menu.props.ts"

export default class MenuApp {
    constructor({
        id,
        tituloGrupoMenu,
        grupoMenu,
        menu,
        device,
        hostImagem
    }: MenuAppProps){
        const el = document.getElementById(id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(
            <Menu
                tituloGrupoMenu={tituloGrupoMenu}
                grupoMenu={grupoMenu}
                menu={menu}
                device={device}
                hostImagem={hostImagem}
            />
        )
    }
}
